/**
 * 饼图颜色
 */
function themeColor (type) {
  switch (type) {
    case 'colorGroup': return ['#2E59A7', '#3C69A6', '#5976BA', '#88ABDA', '#88C4DA', '#88BCDA', '#6BBBE4'];
      break;
    case 'mainColor': return '#385C9C';
      break;
    case 'mainText': return '#303133';
      break;
    case 'lineColor': return ['#385C9C', '#D77F66'];
      break;
    case 'radarContrast': return ['#385C9C', '#D77F66', '#5AA450'];
      break;
    case 'themeRiver': return ['#90DAF4', '#6BBBE4', '#568FC7', '#3E65AB', '#002EA2'];
      break;
    case 'pieColor': return ['#F1896A', '#F4A78F', '#C54A2C', '#ED6C45'];
      break;
    case 'financingValue': return ['#5AAEF3', '#62D9AD', '#5B6E96', '#a8dffa', '#FFDC4C', '#FF974C', '#E65A56', '#6D61E4', '#4A6FE2', '#6D9AE7', '#23C2DB', '#5AAEF3', '#62D9AD', '#5B6E96', '#a8dffa', '#FFDC4C', '#FF974C', '#E65A56', '#6D61E4', '#4A6FE2', '#6D9AE7'];
      break;
    case 'chainPie': return ['#5AAEF3', '#62D9AD', '#5B6E96', '#a8dffa', '#FFDC4C', '#FF974C', '#E65A56', '#6D61E4', '#4A6FE2', '#FF99C3', '#A6559D', '#615EA8', '#195688', '#3C8E34', '#254688', '#4994C4'];
      break;
    case 'techMainColor': return '#9DBEFB';
      break;
    case 'techLineColor': return ['#9DBEFB', '#D7A577'];
      break;
    case 'scatterColor': return ['#9BADCD', '#90BB8E', '#A4C9E1', '#E7CA92', '#FAC79E', '#F3B0AE', '#B0AED3', '#A4B7F0', '#B6CCF3', '#91E0ED', '#9BADCD', '#90BB8E', '#A4C9E1', '#E7CA92', '#FAC79E', '#F3B0AE', '#B0AED3', '#A4B7F0', '#B6CCF3', '#91E0ED'];
      break;
  }
}

export default {
  themeColor: themeColor
};



//////////////////
// WEBPACK FOOTER
// ./static/theme.js
// module id = iAXy
// module chunks = 66